module.exports = ".description {\n  width: 90%;\n  display: -ms-grid;\n  display: grid;\n  -ms-grid-rows: auto auto auto;\n      grid-template-rows: auto auto auto;\n  margin-bottom: 20px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/content/new-offer/new-phone-numbers/new-phone-numbers.component.scss
// module id = ./src/app/content/new-offer/new-phone-numbers/new-phone-numbers.component.scss
// module chunks = main